import { Injectable } from "@angular/core";
import { ItFieldInfo } from "../../model/it-field-info";

@Injectable({
  providedIn: "root",
})
export class SowDetailsService {
  public scopeOfWorkFormValues: ItFieldInfo[];
  constructor() {}
}
